import User from '@/models/User'
import axios from '../../api/vue-axios/axios'

const state = {
  publicPro: {},
  professions: []
}

const mutations = {
  removeCurrentPro (state) {
    state.publicPro = {}
  },
  setPublicPro (state, user) {
    state.publicPro = user
  },
  setProfessions (state, professions) {
    state.professions = professions
  }
}

const getters = {
  currentPro (state) {
    return state.publicPro
  },

  professions (state) {
    return state.professions
  }
}

const actions = {

  removeCurrentPro ({ commit }) {
    commit('removeCurrentPro')
  },

  setPublicPro ({ commit }, pro) {
    return Promise.resolve(commit('setPublicPro', User.fromObject(pro)))
  },

  getProfessions (context) {
    return axios.get('public/users/professions').then((response) => {
      context.commit('setProfessions', response.data.user_professions)
    })
  }

}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/publicPro.js